module.exports = __webpack_public_path__ + "img/icon-effect-chain.7b01eb6d.svg";